import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=1fcc9b5b&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcc9b5b')) {
      api.createRecord('1fcc9b5b', component.options)
    } else {
      api.reload('1fcc9b5b', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=1fcc9b5b&", function () {
      api.rerender('1fcc9b5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-299z7wGPT8D3m/JS/videoIframe.vue"
export default component.exports